"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../../styled"));
var tokens_1 = require("../../../tokens");
var tag_1 = __importDefault(require("../../tag"));
var icon_1 = __importDefault(require("../../icon"));
var StyledTag = styled_1.default(tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: calc(", " / 2);\n  margin-bottom: calc(", " / 2);\n  margin-right: ", ";\n\n  border-color: #dddddd;\n  background-color: ", ";\n  color: #686868;\n\n  ", " {\n    stroke: ", ";\n  }\n"], ["\n  margin-top: calc(", " / 2);\n  margin-bottom: calc(", " / 2);\n  margin-right: ", ";\n\n  border-color: #dddddd;\n  background-color: ", ";\n  color: #686868;\n\n  ", " {\n    stroke: ", ";\n  }\n"])), tokens_1.spacing.xxsmall, tokens_1.spacing.xxsmall, tokens_1.spacing.xxsmall, tokens_1.colors.base.blueLightest, icon_1.default.Element, tokens_1.colors.base.gray);
exports.MultiValue = function (optionProps) {
    var innerProps = optionProps.innerProps, removeProps = optionProps.removeProps, innerRef = optionProps.innerRef, data = optionProps.data;
    return (React.createElement(StyledTag, __assign({}, innerProps, { ref: innerRef, onRemove: removeProps.onClick }), data.label));
};
var templateObject_1;
//# sourceMappingURL=multi-value.js.map